import { addDisplayName, addHandlers, addProps, flowMax } from 'ad-hok'
import { FC } from 'react'
import { Trans } from 'react-i18next'
import { createUseStyles } from 'react-jss'
import { addNavigate } from 'shared/src/utils/addNavigate'

import { addTranslationHelpers } from 'utils/addTranslationHelpers'
import welcomeImage from '../../assets/welcome-image.png'
import { Button } from '../Button'
import { SANS_SERIF_FONT_FAMILY, SERIF_FONT_FAMILY } from '../styles'

const SIDE_PADDING = 24
const useStyles = createUseStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    paddingLeft: SIDE_PADDING,
    paddingRight: SIDE_PADDING,
    color: '#232323',
    height: 'calc(100dvh - 48px)',
    alignItems: 'center',
    justifyContent: 'center',
  },
  welcomeImage: {
    paddingLeft: 15,
    paddingRight: 15,
  },
  title: {
    fontFamily: SERIF_FONT_FAMILY,
    fontWeight: 400,
    fontSize: 48,
    lineHeight: '100%',
    letterSpacing: 0.4,
    color: '#363432',
    paddingLeft: 21,
    paddingRight: 58,
    marginTop: 20,
    marginBottom: 46,
  },
  register: {
    background:
      'radial-gradient(103.73% 266.85% at 0% 16.08%, #CF8355 0%, #CEAF85 38.44%, #9B876D 100%)',
    marginBottom: 45,
  },
  style: {
    fontStyle: 'italic',
    fontWeight: 500,
  },
  alreadyRegisteredText: {
    fontFamily: SANS_SERIF_FONT_FAMILY,
    fontWeight: 700,
    fontSize: 14,
    color: 'rgba(54, 52, 50, 0.8)',
    lineHeight: '187%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    gap: 2,
  },
  linkText: {
    fontWeight: 900,
    color: '#CBA67A',
    '&:hover': {
      cursor: 'pointer',
    },
  },
})

export const Welcome: FC = flowMax(
  addDisplayName('Welcome'),
  addNavigate,
  addHandlers({
    onLogIn:
      ({ navigate }) =>
      () => {
        navigate('/login')
      },
    onSignUp:
      ({ navigate }) =>
      () => {
        navigate('/register')
      },
  }),
  addProps(() => ({
    classes: useStyles(),
  })),
  addTranslationHelpers,
  ({ onLogIn, onSignUp, classes, t }) => (
    <div className={classes.container}>
      <img src={welcomeImage} alt="" className={classes.welcomeImage} />
      <div className={classes.title}>
        <Trans t={t} i18nKey="admin.welcome.title">
          <span className={classes.style} />
        </Trans>
      </div>
      {/* <div className={classes.spelling}>
        <span className={classes.spelling1}>
          {t('admin.welcome.spelling1')}
        </span>
        <span className={classes.spelling2}>
          {t('admin.welcome.spelling2')}
        </span>
      </div>
      <Definition
        label={t('admin.welcome.label1')}
        definition={t('admin.welcome.definition1')}
      />
      <Definition
        label={t('admin.welcome.label2')}
        definition={t('admin.welcome.definition2')}
        className={classes.bottomDefinition}
      />
      <Button
        text={t('admin.welcome.signIn')}
        type="fullWidth"
        onClick={onLogin}
      />
      <div className={classes.buttonSeparator}>
        {t('admin.welcome.buttonSeparator')}
      </div> */}
      <Button
        text={t('admin.welcome.logIn')}
        type="fullWidth"
        onClick={onLogIn}
        className={classes.register}
      />
      <div className={classes.alreadyRegisteredText}>
        {t('admin.welcome.noAccount')}
        <span className={classes.linkText} onClick={onSignUp}>
          {t('admin.welcome.register')}
        </span>
      </div>
    </div>
  )
)
